export const stepper = {
  separator: {
    background: '{surface.600}',
    margin: '0 0 0 1.625rem',
    size: '2px',
  },
  stepNumber: {
    size: '3rem',
    fontSize: '1.2rem',
  },
  colorScheme: {
    light: {
      background: '{surface.100}',
      color: '{neutral.900}',
      borderColor: '#5B5F69',
      step: {
        title: {
          color: '{text.color}',
          active: {
            color: '{text.color}',
          },
        },

        number: {
          color: '{neutral.800}',
          active: {
            background: '{primary.500}',
            color: 'white',
            borderColor: '{primary.500}',
          },
        },
      },
    },
    dark: {
      separator: {
        background: '{surface.100}',
        activeBackground: '{primary.color}',
      },
      steppanel: {
        background: 'transparent',
        color: 'white',
      },
      step: {
        title: {
          color: 'white',
          active: {
            color: 'white',
          },
        },
        number: {
          color: '{neutral.800}',
          active: {
            background: '{primary.500}',
            color: 'white',
            borderColor: '{primary.500}',
          },
        },
      },
    },
  },
};
